import { bindReporter } from "./lib/bindReporter";
import { initMetric } from "./lib/initMetric";
import { observe } from "./lib/observe";
import { onBFCacheRestore } from "./lib/onBFCacheRestore";
export const getFP = (onReport, reportAllChanges) => {
    let metric = initMetric('FP');
    let report;
    const entryHandler = (entry) => {
        // The startTime attribute returns the value of the renderTime if it is not 0,
        // and the value of the loadTime otherwise.
        if (entry.name === 'first-paint') {
            if (po) {
                po.disconnect();
            }
            const value = entry.startTime;
            metric.value = value;
            metric.entries.push(entry);
            report(true);
        }
    };
    const po = observe('paint', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        onBFCacheRestore((event) => {
            // console.log("onBFCacheRestore:",event);
            metric = initMetric('FP');
            report = bindReporter(onReport, metric, reportAllChanges);
            metric.value = performance.now() - event.timeStamp;
            ;
            report(true);
        });
    }
};
